import cls from "pages/MainPage/ui/MainPage.module.scss";
import { classNames } from "shared/lib/classNames/classNames";
import Title from "shared/ui/Title/Title";
import Paragraph, { ParagraphTheme } from "shared/ui/Paragraph/Paragraph";
import DotGridBackground from "../../shared/ui/DotGridBackground";

const PrivacyPage = () => {
    return (
        <div id="mainPage" className={cls.indexPage}>
            <div className={cls.gridBg}>
                <DotGridBackground />
            </div>

            <section className={classNames("page-section", {}, [cls.indexPage__about])}>
                <div className={classNames("container", "container__main")}>
                    <div className={cls.About}>
                        <div className={cls.termsContent}>
                            <Title className={cls.indexPage__title} sentences={["Privacy Policy"]} />

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt24}>
                                SBS CONSULTING STRATEGIES LTD developed the Bloxsy: Steal Games app as a free
                                application. This Service is provided by SBS CONSULTING STRATEGIES LTD at no cost
                                and is intended to be used as-is.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                This page is designed to inform users about our policies regarding the collection,
                                use, and disclosure of personal information for anyone choosing to use our Service.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                By using the Service, you agree to the collection and use of information in
                                accordance with this Privacy Policy. The personal data we collect is used to provide
                                and improve the Service. We do not share your information with anyone except as
                                outlined in this policy.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Unless otherwise defined, terms used in this Privacy Policy have the same meanings
                                as in our Terms and Conditions, which are accessible within Bloxsy: Steal Games.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Information Collection and Use
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                To enhance your experience, we may ask you to provide certain personally
                                identifiable information. This data is retained on your device and is not collected
                                by us directly.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                However, the app may utilize third-party services that may gather data used to
                                identify you.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Third-party services used by the app may include:
                            </Paragraph>

                            <ul className={cls.termsList}>
                                <li>Google Play Services</li>
                                <li>Google Analytics for Firebase</li>
                                <li>Firebase Crashlytics</li>
                            </ul>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We want to inform you that in case of an error in the app, we collect data and
                                information (via third-party tools) from your device called Log Data. This Log Data
                                may include details such as your device’s IP address, device name, operating system
                                version, app configuration at the time of use, time and date of use, and other
                                statistics.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Cookies
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Cookies are small files used to store information and are commonly used as anonymous
                                unique identifiers. These may be sent to your browser from the websites you visit
                                and stored in your device’s internal memory.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                This app does not use cookies directly. However, it may include third-party code and
                                libraries that use cookies to collect data and enhance their services. You can
                                choose to accept or decline these cookies and be notified when a cookie is being
                                sent to your device. Choosing to decline cookies may limit some features of the
                                Service.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Service Providers
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We may engage third-party companies or individuals for purposes including:
                            </Paragraph>

                            <ul className={cls.termsList}>
                                <li>Facilitating the Service</li>
                                <li>Providing the Service on our behalf</li>
                                <li>Performing Service-related functions</li>
                                <li>Assisting in analyzing how the Service is used</li>
                            </ul>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                These third parties may have access to your personal data only to perform specific
                                tasks on our behalf and are obligated not to disclose or use it for any other
                                purpose.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Security
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We value your trust in providing your personal information and strive to use
                                commercially acceptable means of protecting it. However, please remember that no
                                method of internet transmission or electronic storage is 100% secure. Therefore, we
                                cannot guarantee absolute security.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Links to Other Sites
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                The Service may contain links to external websites. If you follow a third-party
                                link, you will be directed to that site. Please note that we do not operate these
                                external sites and strongly recommend reviewing their privacy policies. We have no
                                control over and assume no responsibility for their content, privacy practices, or
                                policies.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Children’s Privacy
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                Our Services are not intended for children under the age of 13. We do not knowingly
                                collect personally identifiable information from children under 13. If we become
                                aware that a child under 13 has provided us with personal data, we will immediately
                                delete it. If you are a parent or guardian and believe your child has provided
                                personal information, please contact us so we can take appropriate action.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Changes to This Privacy Policy
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                We may update our Privacy Policy from time to time. We encourage you to review this
                                page periodically for any changes. Any updates will be posted on this page and will
                                take effect immediately upon posting.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                This policy is effective as of 2025-04-07.
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT} className={cls.mt32}>
                                Contact Us
                            </Paragraph>

                            <Paragraph theme={ParagraphTheme.BRIGHT}>
                                If you have any questions or suggestions about our Privacy Policy, feel free to
                                contact us at: snehapatelwi@gmail.com
                            </Paragraph>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PrivacyPage;
